var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPathPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2648_2425)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2648_2425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4866 0.0336914C29.0995 0.0336914 30.9968 13.2114 30.9968 13.2114L31.0306 26.8638H60.0284V30.9627H19.5131C19.5131 30.9627 0.0683594 28.7574 0.0683594 59.4178C0.0683594 90.0791 17.0402 88.9917 17.0402 88.9917H27.1689V74.7637C27.1689 74.7637 26.6229 57.7918 43.8698 57.7918H72.6305C72.6305 57.7918 88.7891 58.0529 88.7891 42.175V15.9219C88.7891 15.9219 91.2432 0.0336914 59.4866 0.0336914ZM43.4972 9.2147C44.1824 9.21408 44.8611 9.3486 45.4943 9.61054C46.1274 9.87249 46.7028 10.2567 47.1873 10.7413C47.6719 11.2258 48.0561 11.8011 48.318 12.4343C48.58 13.0675 48.7145 13.7462 48.7139 14.4314C48.7145 15.1166 48.58 15.7953 48.318 16.4285C48.0561 17.0617 47.6719 17.637 47.1873 18.1215C46.7028 18.6061 46.1274 18.9903 45.4943 19.2523C44.8611 19.5142 44.1824 19.6487 43.4972 19.6481C42.8119 19.6487 42.1333 19.5142 41.5001 19.2523C40.8669 18.9903 40.2916 18.6061 39.8071 18.1215C39.3225 17.637 38.9383 17.0617 38.6763 16.4285C38.4144 15.7953 38.2799 15.1166 38.2805 14.4314C38.2799 13.7462 38.4144 13.0675 38.6763 12.4343C38.9383 11.8011 39.3225 11.2258 39.8071 10.7413C40.2916 10.2567 40.8669 9.87249 41.5001 9.61054C42.1333 9.3486 42.8119 9.21408 43.4972 9.2147Z",
    fill: "url(#paint0_linear_2648_2425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3489 119.11C90.7361 119.11 88.8388 105.932 88.8388 105.932L88.805 92.2805H59.8066V88.1817H100.322C100.322 88.1817 119.767 90.3869 119.767 59.7257C119.767 29.0648 102.795 30.1522 102.795 30.1522H92.6662V44.3798C92.6662 44.3798 93.2122 61.3516 75.9653 61.3516H47.2045C47.2045 61.3516 31.0459 61.0905 31.0459 76.9689V103.222C31.0459 103.222 28.5922 119.11 60.3485 119.11H60.3489ZM76.3384 109.93C75.6531 109.931 74.9745 109.796 74.3413 109.534C73.7081 109.272 73.1328 108.888 72.6482 108.404C72.1637 107.919 71.7795 107.344 71.5175 106.71C71.2556 106.077 71.1211 105.399 71.1217 104.713C71.121 104.028 71.2555 103.349 71.5174 102.716C71.7793 102.083 72.1635 101.508 72.6481 101.023C73.1326 100.538 73.708 100.154 74.3412 99.8921C74.9744 99.6301 75.6531 99.4956 76.3384 99.4962C77.0236 99.4956 77.7022 99.6301 78.3354 99.8921C78.9686 100.154 79.544 100.538 80.0285 101.023C80.513 101.507 80.8973 102.083 81.1592 102.716C81.4212 103.349 81.5557 104.028 81.5551 104.713C81.5557 105.398 81.4212 106.077 81.1592 106.71C80.8973 107.343 80.513 107.919 80.0285 108.403C79.544 108.888 78.9686 109.272 78.3354 109.534C77.7022 109.796 77.0236 109.93 76.3384 109.93V109.93Z",
    fill: "url(#paint1_linear_2648_2425)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2648_2425",
    x1: 11.5714,
    y1: 10.7439,
    x2: 70.8906,
    y2: 69.4713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2648_2425",
    x1: 47.9809,
    y1: 48.4551,
    x2: 111.683,
    y2: 108.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2648_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2648_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 119.52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathPython);
export default __webpack_public_path__ + "static/media/path-python.fbc3a95b160b38e9a5c2d21fb5bcfe31.svg";
export { ForwardRef as ReactComponent };